import FxTransferContainer from './FxTransferContainer';

export { FxTransferContainer };
